import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDetalhesMetasEducacaoLiquidacao = '/service/contabilidade/transparencia/metaEducacao/'

class DetalhesMetasEducacaoLiquidacaoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    consultar(filtro) {
        let data = {
            sequencial: filtro.sequencial ? filtro.sequencial : '',
        }
        return this.conex.post(urlDetalhesMetasEducacaoLiquidacao + 'consultaMetasEducacaoDetalhesLiquidacao/', JSON.stringify(data))
    }
}

export default DetalhesMetasEducacaoLiquidacaoService
